import { assertNever } from "../../utils/helpers";
import { FileBrowserEntryKind } from "./__generated__/FileBrowserFragment.graphql";
import { File04Icon, FolderIcon } from "@/icons";

export interface FileTypeIconProps {
  fileType: FileBrowserEntryKind;
}

export default function FileTypeIcon({ fileType }: FileTypeIconProps) {
  switch (fileType) {
    case "FILE":
      return <File04Icon />;
    case "DIRECTORY":
      return <FolderIcon />;
    default:
      assertNever(fileType);
  }
}
